import QASection from '@/components/app/upgrade/QASection';
import UpgradeView from '@/components/app/upgrade/UpgradeView';
import { Flex } from 'antd';
import { useState } from 'react';
import useSWR from 'swr';

export default function Upgrade() {
   const { data: plans, error, isLoading } = useSWR('/api/subscription/plans');
   const [billingCycle, setBillingCycle] = useState('yearly');

   return (
      <Flex
         vertical
         align="center"
         gap={16}
         justify="space-between"
         style={{ backgroundColor: '#8E8E9E05', width: '100%', overflow: 'hidden', padding: '16px' }}
      >
         <UpgradeView setBillingCycle={setBillingCycle} billingCycle={billingCycle} plans={plans?.plans || []} />
         <QASection />
      </Flex>
   );
}
